import { render, staticRenderFns } from "./ProjectViewSidebarProgressCard.vue?vue&type=template&id=9f89e0d0&scoped=true"
import script from "./ProjectViewSidebarProgressCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarProgressCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarProgressCard.vue?vue&type=style&index=0&id=9f89e0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f89e0d0",
  null
  
)

export default component.exports